import { createRef, useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import utilsUsers from "../_Utils/utilsUsers";
import { Add, AddCircleOutline, AlignHorizontalLeftRounded, ArrowCircleRightSharp, ArrowCircleUp, ContactlessOutlined, HighlightOff, RemoveCircleOutline } from "@mui/icons-material";
import { MasterContext, OrderContext, UserContext } from "../ContextApi/context";
import { Checkbox } from "@material-ui/core";
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import utilsOrders from "../_Utils/utilsOrders";
import PopUpMsg from "../DTechComp/PopUpMsg";

import Scroll from 'react-scroll';
import { Helmet } from "react-helmet";
import ConnUrls from "../Connections/ConnectURL";
import PopUpClearComp from "../DTechComp/PopUpClearComp";
import PopUpTheComp from "../DTechComp/PopUpTheComp";
import { Button } from "@mui/material";
import AddAddress from "./AddAddress";
var scroller = Scroll.scroller;


const UserAdresses = (props) => {



    const [master, setMaster] = useContext(MasterContext);
    const [order, setOrder] = useContext(OrderContext);

    const [user, setUser, UserEffectFunction] = useContext(UserContext);
    const [userAdds, setUserAdds] = useState([]);

    const [allAds, setAllAds] = useState([]);
    const [thePopUp, setThePopUp] = useState("");

    const [theErrors, setTheErrors] = useState("");
    const [errorsTxts, setErrorsTxts] = useState("");

    const [street, setStreet] = useState("");
    const [num, setNum] = useState("");
    const [appartment, setAppartment] = useState("");
    const [ent, setEnt] = useState("");
    const [city, setCity] = useState("");
    const [flor, setFlor] = useState("");

    const [remarks, setRemarks] = useState("");
    const [delivPrice, setDelivPrice] = useState("");
    const [showAddNew, setShowAddNew] = useState(false);

    const [theSele, setTheSele] = useState("");
    const deliveryCitys = props.deliveryCitys && props.deliveryCitys.length != 0 ? props.deliveryCitys : [];

    const [selectedAddId, setSelectedAddId] = useState("");


    let popTiming = 0;


    const history = useHistory();

    useEffect(() => {
        if (order.restId != null && order.restId != "") {

            getAllAdresses();

        }
        else {
            history.push("/")
        }
    }, [])

    useEffect(() => {

        let theSelectdAdd = order.deliveryAddress?._id || "";

        setTheSele(theSelectdAdd)

    }, [order])


    const getAllAdresses = async () => {
        const res = await utilsUsers.getAdresses(user._id);
        setUserAdds(res);

        const curId = order?.deliveryAddress?._id || "";
        const matched = curId && res.some(a => a._id === curId);

        if (matched) {
            setSelectedAddId(curId);                             // state לבחירה
        } else {
            setSelectedAddId("");                                // אין התאמה
        }

        setAddrs(res, curId);



        // order.deliveryAddress?._id === addrs._id
    }




    const setTheSelectedAdd = (isChecked, addId, userAdds) => {

        const id = isChecked ? addId : "";
        setSelectedAddId(id);
        setUserAdds(userAdds);
        const theitm = userAdds.find(itm => itm._id === id) || null;
        // order נשאר עם אובייקט ולא מחרוזת
        setOrder(prev => ({
            ...prev,
            deliveryAddress: theitm ? { ...theitm } : {},
        }));
        setAddrs(userAdds, id);

    }



    //מציג את כל הכתובות הקיימות ומסמן את הנבחרת
    const setAddrs = (userAdds, newSelection) => {

        const activeId = newSelection || selectedAddId;
        // setSelectedAddId(activeId)
        let addresses = userAdds.map((addrs, index) => {

            const cityInfo = deliveryCitys.find((c) => c.cityName === addrs.city);
            if (!cityInfo) return null;

            let isChecked = activeId ? addrs._id === activeId : false;

            let tempitm = userAdds.filter(ad => ad.city === cityInfo.cityName);
            if (tempitm.length === 1) {
                setSelectedAddId(tempitm[0]._id)
                isChecked = true;
            }

            addrs.deliveryPrice = cityInfo.deliveryPrice;

            return (
                <table style={{ width: "100%" }}>
                    <tbody>
                        <tr key={index} className={"firstDelTd pointing"} >

                            <div className={`grayFrame grayFrameSpecial ${isChecked ? "selectdFrameYelow" : ""}`}>
                                <td className={"firstDelTd"} onClick={() => (!isChecked) ? setTheSelectedAdd(!isChecked, addrs._id, userAdds) : {}}>
                                    <Checkbox checked={isChecked}
                                        icon={<RadioButtonUncheckedIcon
                                            style={{
                                                color: "var(--lGray)",
                                                borderRadius: "30px",
                                            }} />}
                                        checkedIcon={<CheckCircleIcon style={{
                                            color: "var(--mainYellow)",
                                            borderRadius: "30px",
                                        }} />}
                                        sx={{
                                            '& .MuiSvgIcon-root': { fontSize: 24 }, // גודל איקון אם צריך
                                        }}
                                        onChange={(e) => (!isChecked) ? setTheSelectedAdd(e.target.checked, addrs._id, userAdds) : {}} />
                                </td>
                                <td className={"addressDelTd"} onClick={() => (!isChecked) ? setTheSelectedAdd(!isChecked, addrs._id, userAdds) : {}} >
                                    {`
                ${addrs.street} 
                ${addrs.num}                  
               
                 ${(addrs.appartment != null && addrs.appartment != "") ? `דירה: ${addrs.appartment}` : ""} 
                  ${(addrs.ent != null && addrs.ent != "") ? `כניסה: ${addrs.ent}` : ""} 
                 
                  ${(addrs.flor != null && addrs.flor != "" && addrs.num != "") ? `קומה: ${addrs.flor}` : ""}
                  ${(addrs.city != null && addrs.city != "") ? ` ${addrs.city} ( ₪${addrs.deliveryPrice} )` : " "}
                `}
                                    <br />
                                    {`
                 ${(addrs.remarks != "") ? `הערות לשליח: ${addrs.remarks}` : ""}
                 `}
                                </td>

                                {!isChecked &&
                                    <td className={"firstDelTd"} onChange={() => removeAddress(addrs._id, activeId)} >
                                        <Checkbox checked={isChecked}
                                            icon={
                                                <RemoveCircleOutline
                                                    style={{
                                                        color: "var(--specialRed)",
                                                        borderRadius: "30px"
                                                    }}
                                                    onChange={() => removeAddress(addrs._id, activeId)} />
                                            }
                                        />
                                    </td>
                                }
                            </div>
                        </tr>
                    </tbody>
                </table>
            )
        })



        setAllAds(addresses);
        // if (addresses.length <= 0)  showAddrsPop(true);
    }

    //אם הכל תקין בבחירת כתובת, מחזיר את האיידי של הכתובת הנבחרת
    const finishOrder = async (activeId) => {
        if (!activeId) {
            setTheErrors("selectAdd");
            setErrorsTxts("נא לבחור כתובת למשלוח");
            return;
        }

        setTheErrors("");
        setErrorsTxts("");
        const chosen = userAdds.find(a => a._id === activeId);

        props.setTheAddress(chosen);
        props.GoTOPay();

    }

    const goToBack = () => {
        history.goBack();

        // if (document.referrer.indexOf(window.location.host) === -1) {
        // }
        // else {
        //      history.push('/'); }
    }


    const showAddrsPop = (closeMain) => {
        
        setThePopUp(
            <div key={"addressBoxSet"} id={"addressBoxSet"} className={"addressBox"}>
                <AddAddress
                    noHead={true}
                    addId={"NewAddressAdd"}
                    deliveryCitys={deliveryCitys}
                    setAddrs={(newaddAdres) => { newAddressSeting(newaddAdres) }}
                    closeMe={() => { setThePopUp() }}
                />
            </div>)




    }

    const removeAddress = async (addsId, activeId) => {

        let userAddsIn = await utilsUsers.removeAddress(user._id, { addToRemove: addsId });
        let tempoSle = userAddsIn.filter((add) => add._id != addsId);

        setAddrs(tempoSle, activeId);


    }

    //לאחר שנוצר אובייקט כתובת חדש מעדכן אותה כנבחר בהזמנה
    const newAddressSeting = (newaddAdres) => {

        setTheErrors("");
        setErrorsTxts("");

        const last = newaddAdres[newaddAdres.length - 1];

        setOrder(prev => ({ ...prev, deliveryAddress: { ...last } }));
        setUserAdds(newaddAdres)
        setSelectedAddId(last._id);
        setAddrs(newaddAdres, last._id);

        // setOrder(prev => ({
        //     ...prev,
        //     deliveryAddress: newaddAdres[newaddAdres.length - 1] ? { ...newaddAdres[newaddAdres.length - 1] } : {},
        // }));


        // setAddrs(newaddAdres, newaddAdres[newaddAdres.length - 1]._id)



    }

    return (
        <div id={props.addId} className={"loginPage"}>
            {!props.noHead ? <div className={"headOnFixC SecondFont bold big"}>
                כתובת למשלוח
                <div className={`backSd`}>
                    <ArrowCircleRightSharp onClick={() => goToBack()} />
                </div>
                <br />
            </div>
                : ""}

            <div className={"firstMastSec"}>

                {props.noHead ? <div className={"sideClosBtn halfspin"} onClick={() => props.closeMe()}>
                    <HighlightOff />
                </div>
                    : ""}


                <div className={"bold huge centerText"}>לאן לשלוח את ההזמנה?</div>
                <br />
                <div className="fullWidth spaceButtomBig pointing">
                    <div className={"btnWithIconWrap"}>
                        <div className={"btnWithIcon_white"} variant="outlined"
                            onClick={() => showAddrsPop()}
                        >
                            <Add className="plusOnAddRes" />
                            <span>הוסף כתובת</span>
                        </div>
                    </div>
                </div>
                {
                    (theErrors != "") ?
                        <div className={"errorLine"}>
                            {
                                (!theErrors.includes("address") &&
                                    !theErrors.includes("num") &&
                                    errorsTxts != "") ?
                                    <p className={"vsmall bold"}>- {errorsTxts}</p> :
                                    <p className={"big bold"}>{"התאים המסומנים הינם חובה"}</p>

                            }
                        </div>
                        : (errorsTxts != "") ?
                            <div className={"errorLine"}>
                                <p className={"vsmall bold"}>- {errorsTxts}</p> </div> : ""
                }

                <div>

                    {allAds}


                </div>
                {!showAddNew && allAds !== "" && (
                    <div className="ContinueToPayLine full" onClick={() => { }}>
                        <div className="getToKnowBtn bold big centerText" onClick={() => { finishOrder(selectedAddId) }}>
                            המשך
                        </div>
                    </div>
                )
                }
                {thePopUp}
            </div>
            {/* <Helmet
                meta={[
                    {
                        property: "og:url", content: `${ConnUrls.siteDomainNam}/deliAdress`
                    }
                ]}>
                <link rel="canonical" href={`${ConnUrls.siteDomainNam}/deliAdress`} />
            </Helmet> */}
        </div>


    )

}

export default UserAdresses